import { Link } from 'react-router-dom';
import Reveal from '../ui/Reveal';
import { ArrowRight, Sparkle } from '../ui/Icons';
import { MARMOVELLA, MARMOVELLA_WARRANTY } from '../../data/marmovella';

/** Homepage launch feature for the Fine Square Marmovella mineral stone finish. */
const MarmovellaFeature = () => (
  <section className="relative overflow-hidden bg-[#0b0d1a] text-white">
    <div className="pointer-events-none absolute -top-40 right-0 w-[34rem] h-[34rem] rounded-full bg-[#b8902f]/25 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-40 -left-32 w-[30rem] h-[30rem] rounded-full bg-brand-blue/30 blur-3xl" />
    <div className="relative container py-16 md:py-24 grid lg:grid-cols-12 gap-10 lg:gap-14 items-center">
      <Reveal className="lg:col-span-6">
        <Link to="/Marmovella" className="group block" aria-label="Explore Marmovella">
          <img
            src="/images/marmovella/marmovella-buckets-cutout.webp"
            alt="Marmovella Classico, Granito and Lusso 20 L packs"
            loading="lazy"
            className="w-full h-auto drop-shadow-[0_30px_40px_rgba(0,0,0,.55)] transition-transform duration-700 group-hover:scale-[1.03]"
          />
        </Link>
      </Reveal>
      <Reveal delay={1} className="lg:col-span-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-brand-gold text-brand-ink px-3.5 py-1.5 text-xs font-bold tracking-wider uppercase">
          <Sparkle size={13} /> Introducing
        </span>
        <h2 className="vp-display mt-5 text-5xl sm:text-6xl bg-gradient-to-r from-[#f5dea0] via-brand-gold to-[#c9a14a] bg-clip-text text-transparent">Marmovella</h2>
        <p className="mt-2 text-sm font-semibold tracking-[.3em] uppercase text-white/75">Italian mineral stone finish</p>
        <p className="mt-5 text-white/75 leading-relaxed max-w-xl">
          Walls that inspire forever. A trowel-applied mineral finish from Fine Square in three characters — and an {MARMOVELLA_WARRANTY.years}-year system
          warranty when applied as a complete system.
        </p>
        <div className="mt-7 grid sm:grid-cols-3 gap-3">
          {MARMOVELLA.map((f) => (
            <Link key={f.id} to={`/Marmovella#${f.id}`} className="group rounded-2xl bg-white/5 border border-white/10 hover:border-[#c9a14a]/60 p-3 transition-colors">
              <span className="grid grid-cols-3 gap-1">
                {f.shades.slice(0, 3).map((s) => (
                  <span key={s.name} className="block aspect-square rounded-md overflow-hidden">
                    <img src={s.image} alt="" loading="lazy" className="w-full h-full object-cover" />
                  </span>
                ))}
              </span>
              <span className="block mt-3 font-semibold group-hover:text-brand-gold transition-colors">{f.name.replace('Marmovella ', '')}</span>
              <span className="block text-xs text-white/60">{f.tagline}</span>
            </Link>
          ))}
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/Marmovella" className="vp-btn vp-btn-gold">
            Discover Marmovella <ArrowRight />
          </Link>
          <Link to="/Marmovella#shades" className="vp-btn vp-btn-ghost">
            See all 16 shades
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default MarmovellaFeature;
